<template>
	<div class="expense-input">
		<!-- Standard expense input -->
		<template v-if="!isCustom">
			<div class="contentColumnLeftIgnoreMobile">
				<label
					:for="inputId"
					class="expense-label disabledValue"
				>
					{{ expense.description }}
				</label>
			</div>
			<div class="contentColumnRightIgnoreMobile">
				<input
					:id="inputId"
					v-model="localAmount"
					type="text"
					class="textInputLarge value"
					placeholder="Amount"
					:disabled="isDisabled"
					:aria-label="`${expense.description} amount`"
					:aria-disabled="isDisabled"
					@input="handleInput"
				/>
			</div>
		</template>

		<!-- Custom expense input -->
		<template v-else>
			<div class="contentColumnLeftIgnoreMobile">
				<input
					:id="`${inputId}-description`"
					v-model="localDescription"
					type="text"
					class="textInputLarge"
					placeholder="New Expense Description"
					:disabled="isDisabled"
					:aria-label="expense.description || 'Custom expense description'"
					:aria-disabled="isDisabled"
					@input="handleInput"
				/>
			</div>
			<div class="contentColumnRightIgnoreMobile">
				<input
					:id="`${inputId}-amount`"
					v-model="localAmount"
					type="text"
					class="textInputLarge"
					placeholder="Amount"
					:disabled="isDisabled"
					:aria-label="'Amount'"
					:aria-disabled="isDisabled"
					@input="handleInput"
				/>
			</div>
		</template>
	</div>
</template>

<script>
	export default {
		name: 'ExpenseInput',

		props: {
			/**
			 * The expense object
			 * @type {Object}
			 * @property {string} type - The type of expense
			 * @property {string} amount - The amount of the expense
			 * @property {string} description - The description of the expense
			 */
			expense: {
				type: Object,
				required: true,
				validator(value) {
					return value.hasOwnProperty('type') && value.hasOwnProperty('amount')
				}
			},
			/**
			 * Whether the expense input is disabled
			 * @type {boolean}
			 * @default false
			 */
			isDisabled: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				localAmount: this.expense.amount || '',
				localDescription: this.expense.description || '',
				inputId: `expense-${this.expense.type}-${Date.now()}`
			}
		},

		computed: {
			/**
			 * Check if the expense is custom
			 * @returns {boolean} True if the expense is custom, false otherwise
			 */
			isCustom() {
				return this.expense.type === 'other'
			}
		},

		watch: {
			/**
			 * Watch for changes in the expense amount
			 * @param {string} newVal - The new amount
			 */
			'expense.amount'(newVal) {
				this.localAmount = newVal
			},
			/**
			 * Watch for changes in the expense description
			 * @param {string} newVal - The new description
			 */
			'expense.description'(newVal) {
				this.localDescription = newVal
			}
		},

		methods: {
			/**
			 * Handle input changes
			 * @param {Event} event - The input event
			 */
			handleInput: function () {
				this.$emit('update', {
					...this.expense,
					amount: this.localAmount,
					description: this.isCustom ? this.localDescription : this.expense.description
				})
			}
		}
	}
</script>

<style scoped></style>
